import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const ACTIONS_CLOSED = 'moreButton/ACTIONS_CLOSED';

export const actionsClosed = createAction(ACTIONS_CLOSED);
